var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "founded-property-strip",
    "class": {
      'is-empty': _vm.foundedProperties.length === 0
    },
    attrs: {
      "id": "w-node-_33df7b64-d3e3-9bb8-c9ea-7c0b79a8b3cc-5bbc1f5a"
    }
  }, [_c('div', {
    staticClass: "property-strip-heading"
  }, [_c('img', {
    staticClass: "property-strip-icon",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f3a_property%20icon.png",
      "loading": "lazy",
      "alt": "Zakladané nehnuteľnosti"
    }
  }), _c('div', {
    staticClass: "property-strip-copy"
  }, [_c('div', {
    staticClass: "property-strip-title"
  }, [_vm._v("Zakladané nehnuteľnosti")]), _vm.foundedProperties.length ? _c('div', {
    staticClass: "property-strip-description"
  }, [_vm._v(" " + _vm._s(_vm.foundedProperties.length) + " " + _vm._s(_vm.foundedPropertyCountLabel) + " · hodnota spolu "), _c('strong', [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.totalFoundedValue)) + " EUR")])]) : _c('div', {
    staticClass: "property-strip-description"
  }, [_vm._v(" Bez zabezpečenia sú LTV a ponuky bánk iba orientačné. ")])]), _c('div', {
    staticClass: "property-status",
    "class": {
      'is-complete': _vm.foundedProperties.length
    }
  }, [_vm._v(" " + _vm._s(_vm.foundedProperties.length ? 'Zabezpečenie zadané' : 'Chýba zabezpečenie') + " ")])]), _c('div', {
    staticClass: "property-strip-content"
  }, [_vm.foundedProperties.length ? _c('div', {
    staticClass: "property-list"
  }, _vm._l(_vm.foundedProperties, function (property, key) {
    return _c('div', {
      key: key,
      staticClass: "property-summary p-relative"
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.remove(property.id);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "closebtn-broker-app pointer edit",
      on: {
        "click": function click($event) {
          return _vm.finishProperty(property);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"
      }
    })]), _c('div', {
      staticClass: "property-address"
    }, [_vm._v(_vm._s(_vm.getAddressModified(property)))]), property.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "property-value"
    }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(property.hodnota)) + " EUR")])], 1);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "property-strip-action"
  }, [_c('client-property-handler', {
    attrs: {
      "rules": ['priority'],
      "type": 'zakladane_nehnutelnosti',
      "title": _vm.foundedProperties.length ? '+ pridať ďalšiu NEHNUTEĽNOSŤ' : '+ pridať zakladanú NEHNUTEĽNOSŤ'
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }